type Element = "wood" | "fire" | "earth" | "metal" | "water";

const elementVi: Readonly<Record<Element, string>> = Object.freeze({
  wood: "Mộc",
  fire: "Hỏa",
  earth: "Thổ",
  metal: "Kim",
  water: "Thủy",
});

const stemVi: Readonly<Record<string, string>> = Object.freeze({
  甲: "Giáp",
  乙: "Ất",
  丙: "Bính",
  丁: "Đinh",
  戊: "Mậu",
  己: "Kỷ",
  庚: "Canh",
  辛: "Tân",
  壬: "Nhâm",
  癸: "Quý",
});

const stemElement: Readonly<Record<string, Element>> = Object.freeze({
  甲: "wood",
  乙: "wood",
  丙: "fire",
  丁: "fire",
  戊: "earth",
  己: "earth",
  庚: "metal",
  辛: "metal",
  壬: "water",
  癸: "water",
});

const branchVi: Readonly<Record<string, string>> = Object.freeze({
  子: "Tý",
  丑: "Sửu",
  寅: "Dần",
  卯: "Mão",
  辰: "Thìn",
  巳: "Tỵ",
  午: "Ngọ",
  未: "Mùi",
  申: "Thân",
  酉: "Dậu",
  戌: "Tuất",
  亥: "Hợi",
});

const branchElement: Readonly<Record<string, Element>> = Object.freeze({
  子: "water",
  丑: "earth",
  寅: "wood",
  卯: "wood",
  辰: "earth",
  巳: "fire",
  午: "fire",
  未: "earth",
  申: "metal",
  酉: "metal",
  戌: "earth",
  亥: "water",
});

export type CanChiTranslation = Readonly<{
  textVi: string;
  explanationVi: string;
  isKnown: boolean;
}>;

export function translateStem(stem: string): string | undefined {
  return stemVi[stem];
}

export function translateBranch(branch: string): string | undefined {
  return branchVi[branch];
}

export function translateCanChi(
  stem: string,
  branch: string,
): CanChiTranslation {
  const stemKey =
    stemVi[stem] === undefined
      ? Object.keys(stemVi).find((key) => stemVi[key] === stem)
      : stem;
  const branchKey =
    branchVi[branch] === undefined
      ? Object.keys(branchVi).find((key) => branchVi[key] === branch)
      : branch;
  const stemNameVi = stemKey === undefined ? undefined : stemVi[stemKey];
  const branchNameVi =
    branchKey === undefined ? undefined : branchVi[branchKey];
  const stemEl = stemKey === undefined ? undefined : stemElement[stemKey];
  const branchEl =
    branchKey === undefined ? undefined : branchElement[branchKey];

  if (!stemNameVi || !branchNameVi || !stemEl || !branchEl) {
    return Object.freeze({
      textVi: "Chưa xác định được can chi",
      explanationVi: "Dữ kiện can chi nằm ngoài bảng ánh xạ kỹ thuật hiện có.",
      isKnown: false,
    });
  }

  return Object.freeze({
    textVi: `${stemNameVi} ${branchNameVi}`,
    explanationVi: `Can ${stemNameVi} thuộc ${elementVi[stemEl]}, chi ${branchNameVi} thuộc ${elementVi[branchEl]}.`,
    isKnown: true,
  });
}

export function translateElement(element: string): string | undefined {
  return elementVi[element as Element];
}
